// Destinations come only from the production-owned physical address.
export function googleMapsLinks(address) {
 const destination=typeof address==='string'?address.trim():'';
 if(!destination)return null;
 const encoded=encodeURIComponent(destination);
 return {
  view:`https://www.google.com/maps/search/?api=1&query=${encoded}`,
  directions:`https://www.google.com/maps/dir/?api=1&destination=${encoded}`,
 };
}